import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileBookingBar from "./MobileBookingBar";
import CookieBanner from "./CookieBanner";

const Layout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-cream">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
    <MobileBookingBar />
    <CookieBanner />
  </div>
);

export default Layout;
